'use strict';

var _module$component;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../webComponents/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[Load]');

var LoadController = function () {
    function LoadController($scope) {
        _classCallCheck(this, LoadController);

        this.$scope = $scope;
    }

    _createClass(LoadController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Possible states:
            // initial - Starting state, no promise to watch
            // pending - Waiting for data
            // ready - Data loaded, ready to display
            // error - Something went wrong
            this.set('initial');

            this.$scope.$watch(function () {
                return _this.promise;
            }, function (promise) {
                if (promise === undefined) {
                    // Not set yet
                    _this.set('initial');
                } else if (promise && promise.then) {
                    // It's a promise
                    _this.set('pending');
                    promise.then(function (value) {
                        if (promise === _this.promise) {
                            _this.set('ready', value);
                        } else {
                            // The promise was replaced with a different one already.
                            // Ignore the result, do not change component state.
                        }
                    }, function (error) {
                        if (promise === _this.promise) {
                            log.error('Promise failed:', error);
                            _this.set('error', error);
                        } else {
                            // As above, the promise that finished was an outdated one.
                            // Log the error, but don't change component state.
                            log.warn('Stale promise failed:', error);
                        }
                    });
                } else {
                    // It's something else
                    _this.set('error');
                    log.error('Parameter value is not a promise:', promise);
                }
            });
        }

        // Set the component state.
        // Value can be undefined when setting a non-error state.

    }, {
        key: 'set',
        value: function set(state, value) {
            this.state = state;

            if (value === undefined) {}
            // Could set this to some other value to mark that it's not set,
            // but undefined works well enough as it is.
            // value = null;


            // Set the value in the controller scope.
            // It will be read by the load-x controllers.
            this.value = value;
        }
    }]);

    return LoadController;
}();

LoadController.$inject = ['$scope', '$transclude', '$element'];

_module3.default.component('load', (_module$component = {
    transclude: true,
    template: require('./load.html'),
    controller: LoadController
}, _defineProperty(_module$component, 'transclude', {
    initial: '?loadInitial',
    ready: '?loadReady',
    pending: '?loadPending',
    error: '?loadError'
}), _defineProperty(_module$component, 'bindings', {
    promise: '<'
}), _module$component));

var LoadInitialController = function LoadInitialController() {
    _classCallCheck(this, LoadInitialController);
};

_module3.default.component('loadInitial', {
    transclude: true,
    template: '<ng-transclude ng-if="$ctrl.loadCtrl.state === \'initial\'"></ng-transclude>',
    controller: LoadInitialController,
    require: {
        loadCtrl: '^^load'
    }
});

var LoadPendingController = function LoadPendingController() {
    _classCallCheck(this, LoadPendingController);
};

_module3.default.component('loadPending', {
    transclude: true,
    template: '<ng-transclude ng-if="$ctrl.loadCtrl.state === \'pending\'"></ng-transclude>',
    controller: LoadPendingController,
    require: {
        loadCtrl: '^^load'
    }
});

var LoadStateController = function () {
    function LoadStateController($scope, $transclude, $element, targetState) {
        _classCallCheck(this, LoadStateController);

        this.$scope = $scope;
        this.$transclude = $transclude;
        this.$element = $element;
        this.targetState = targetState;
    }

    _createClass(LoadStateController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            // Transcluded content
            this.transContent = null;
            this.transScope = null;

            this.$scope.$watchCollection(function () {
                return { state: _this2.loadCtrl.state, value: _this2.loadCtrl.value };
            }, function (x) {
                return _this2.update(x.state, x.value);
            });
        }
    }, {
        key: 'update',
        value: function update(loadState, value) {
            var _this3 = this;

            if (loadState === this.targetState && this.transContent === null) {
                // We should show the content but haven't added it to the component yet.
                // Add the content and store its scope so we can access it.
                this.$transclude(function (clone, scope) {
                    _this3.$element.append(clone);
                    _this3.transContent = clone;
                    _this3.transScope = scope;
                });
            } else if (loadState !== this.targetState && this.transContent !== null) {
                // We are showing the content, but we shouldn't be any more.
                // Remove the content from the DOM.
                this.transScope.$destroy();
                this.$element.empty();
                this.transScope = null;
                this.transContent = null;
            }

            // If the transcluded scope exists, set/update the value property on it.
            if (this.transScope) {
                this.transScope.value = value;
            }
        }
    }]);

    return LoadStateController;
}();

var LoadReadyController = function (_LoadStateController) {
    _inherits(LoadReadyController, _LoadStateController);

    function LoadReadyController($scope, $transclude, $element) {
        _classCallCheck(this, LoadReadyController);

        return _possibleConstructorReturn(this, (LoadReadyController.__proto__ || Object.getPrototypeOf(LoadReadyController)).call(this, $scope, $transclude, $element, 'ready'));
    }

    return LoadReadyController;
}(LoadStateController);

LoadReadyController.$inject = ['$scope', '$transclude', '$element'];

_module3.default.component('loadReady', {
    transclude: true,
    controller: LoadReadyController,
    template: '',
    require: {
        loadCtrl: '^^load'
    }
});

var LoadErrorController = function (_LoadStateController2) {
    _inherits(LoadErrorController, _LoadStateController2);

    function LoadErrorController($scope, $transclude, $element) {
        _classCallCheck(this, LoadErrorController);

        return _possibleConstructorReturn(this, (LoadErrorController.__proto__ || Object.getPrototypeOf(LoadErrorController)).call(this, $scope, $transclude, $element, 'error'));
    }

    return LoadErrorController;
}(LoadStateController);

LoadErrorController.$inject = ['$scope', '$transclude', '$element'];

_module3.default.component('loadError', {
    transclude: true,
    controller: LoadErrorController,
    template: '',
    require: {
        loadCtrl: '^^load'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/core/load.js
// module id = 66
// module chunks = 0 2